import type { PhoneNumber } from '@mend/types/phone-number';
import type { Response } from '#types/common.ts';

import { api } from '../http-clients.ts';

type PhoneLookupResponse = {
  numbers: PhoneNumber[];
};

export const phoneLookup = (
  numbers: string | string[],
  signal?: AbortSignal
): Promise<PhoneNumber[]> =>
  api
    .put<
      Response<PhoneLookupResponse>
    >('/phone/lookup', { numbers: Array.isArray(numbers) ? numbers : [numbers] }, { signal })
    .then((res) => res.data.payload.numbers);
